import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-unineue-bold text-20" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "font-unineue-bold text-20 mb-4" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_detail_section = _resolveComponent("detail-section")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ion_img, {
      src: _ctx.content.image,
      class: "w-full h-auto object-cover w-full overflow-hidden rounded-12"
    }, null, 8, ["src"]),
    _createElementVNode("h6", _hoisted_1, _toDisplayString(_ctx.content.title), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "font-helvetica text-mid-dark-grey maintext spacing-1 mb-4",
        innerHTML: _ctx.content.mainText
      }, null, 8, _hoisted_3),
      _createElementVNode("div", {
        class: "font-helvetica text-mid-dark-grey subtext spacing-1",
        innerHTML: _ctx.content.subText
      }, null, 8, _hoisted_4)
    ]),
    (_ctx.content.features?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.features, (feature) => {
            return (_openBlock(), _createBlock(_component_detail_section, {
              key: feature.anchor,
              noPadding: "",
              id: feature?.anchor
            }, {
              default: _withCtx(() => [
                _createElementVNode("h6", _hoisted_6, _toDisplayString(feature.title), 1),
                _createVNode(_component_ion_img, {
                  src: feature.image,
                  class: "w-full h-full object-cover w-full overflow-hidden rounded-12 mb-4"
                }, null, 8, ["src"]),
                _createElementVNode("div", {
                  class: "description font-unineue-book",
                  innerHTML: feature.description
                }, null, 8, _hoisted_7)
              ]),
              _: 2
            }, 1032, ["id"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}